module.exports = __webpack_public_path__ + "img/menu_soup_mushroom@3x.b0313366.png";